<script setup lang="ts">
    /**
     * Wrapper around Vuetify's `VNumberInput` with the app's default variant
     * and stacked increment/decrement controls. Non-declared attrs forward
     * to the root `v-number-input` via Vue's default attr inheritance.
     *
     * `min` and `max` are intentionally not forwarded: Vuetify's built-in
     * clamp silently rejects button clicks once the model is outside the
     * range (each intermediate step is also out of range), leaving the
     * input stuck. Consumers should rely on their own validation layer
     * (error-messages) for range enforcement.
     *
     * See https://vuetifyjs.com/en/api/v-number-input/ for the full prop list.
     */
    defineProps<{
        step?: number;
        errorMessages?: string | string[];
        density?: 'default' | 'comfortable' | 'compact';
    }>();

    const model = defineModel<number | null>();
</script>

<template>
    <v-number-input
        v-model="model"
        :step="step"
        :error-messages="errorMessages"
        :density="density"
        variant="outlined"
        control-variant="stacked"
        hide-details="auto"
    ></v-number-input>
</template>

<style scoped>
    .v-number-input :deep(.v-input__control) {
        width: 100px;
    }

    .v-number-input :deep(.v-field__input) {
        padding: 10px 14px;
        height: 100%;
    }

    .v-number-input :deep(.v-divider) {
        display: none;
    }

    .v-number-input :deep(.v-number-input__control) {
        padding: 10px 14px;
    }
</style>
